
export const getNormalizedVehicle = (vehicle = {}, meta = {}) => {
  const defaultMeta = {
    searchId: '',
  };
  const clonedVehicle = JSON.parse(JSON.stringify(vehicle));
  const clonedMeta = JSON.parse(JSON.stringify(meta));
  const defaultVehicle = {
    _meta: Object.assign(defaultMeta, clonedMeta),
    id: 0,
    categories: [],
    dealer: {
      agentImageUrl: '',
      agentName: '',
      email: '',
      id: '',
      location: {
        city: '',
        street: '',
        zip: '',
        geoCoordinates: {
          lat: 0,
          lon: 0,
        },
        country: '',
      },
      name: '',
      openingTimes: [],
      phone: '',
      leadPhone: '',
      active: false,
      fdlConditions: '',
    },
    display: null,
    displayBodyColor: '',
    doors: 0,
    emissionPerKm: 0,
    emissionClass: '',
    emissionSticker: '',
    externalId: '',
    features: [],
    firstRegistrationDate: '',
    fuelConsumptionCombined: 0,
    fuelConsumptionInner: 0,
    fuelConsumptionOuter: 0,
    fuelType: '',
    gearBox: '',
    guarantee: 0,
    bodyColor: '',
    images: [],
    make: {
      displayName: '',
      id: '',
    },
    mileage: 0,
    model: {
      displayName: '',
      id: '',
      source: '',
      trim: '',
    },
    performance: 0,
    price: 0,
    previousOwners: 1,
    state: 'PUBLISHED',
    serviceBook: false,
    motDate: '',
    motRenewEligible: false,
    warranty: false,
    seats: 0,
    energyEfficiencyClass: '',
    interiorType: '',
    singleDayRegistration: false,
    envkv: false,
    accidentDamaged: false,
    usedCarSeal: null,
    vatRate: 19,
    vatReclaimable: false,
    financing: {
      calculation: {
        finalRate: null,
        interest: null,
        interestRateEff: null,
        interestRateNominal: null,
        interestSum: null,
        netCreditAmount: null,
        rate: null,
        totalSum: null,
      },
      parameters: {
        campaignId: null,
        dealerId: null,
        downPayment: null,
        duration: null,
        durationOptions: null,
        mileage: null,
        mileageOptions: null,
        rsv: null,
      },
    },
    financingPrecalc: {
      requestId: '',
      tabs: [],
      inputs: [],
      optionals: [],
      result: {
        label: '',
        summary: [],
        price: {
          label: '',
          value: 0,
          format: '',
          disclaimerRef: null,
        },
      },
      disclaimers: [],
      specificData: {},
    },
    live: true,
  };

  const removeFromVehicle = [
    'airbags',
    'climatisation',
    'cubicCapacity',
    'dealerId',
    'financingAnnualInterestRate',
    'financingFinalInstallment',
    'financingFirstInstallment',
    'financingMonthlyInstallment',
    'financingPeriod',
    'imageBatchId',
    'metallic',
    'remarks',
    'score',
  ];

  const removeFromDealer = [
    'latestContractSignature',
    'leadEmail',
    'leadFormat',
    'network',
  ];

  const vehicleObject = Object.assign(defaultVehicle, clonedVehicle);

  removeFromVehicle.forEach(key => {
    delete vehicleObject[key];
  });
  removeFromDealer.forEach(key => {
    delete vehicleObject.dealer[key];
  });

  return vehicleObject;
};

